import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["mediaClientConfig", "mediaSettings"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { MediaClientContext } from './MediaClientProvider';
import { MediaContext, MediaProvider } from './MediaProvider';
import { useMediaParsedSettings } from './mediaSettings';
var MediaContextConsumer = function MediaContextConsumer(_ref) {
  var Component = _ref.Component,
    otherProps = _ref.otherProps;
  return /*#__PURE__*/React.createElement(MediaContext.Consumer, null, function (mediaProviderValue) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
      mediaClient: mediaProviderValue === null || mediaProviderValue === void 0 ? void 0 : mediaProviderValue.mediaClient,
      mediaSettings: mediaProviderValue === null || mediaProviderValue === void 0 ? void 0 : mediaProviderValue.settings
    }));
  });
};

/**
 * Injects a MediaProvider as a partent of the supplied component, if no MediaProvider or MediaClientProvider is found in the tree.
 * It also conciliates the passed mediaClientConfig and mediaSettings with the Provider settings, giving priority to the passed props.
 */
export var withMediaClientAndSettings = function withMediaClientAndSettings(Component) {
  return function (_ref2) {
    var mediaClientConfig = _ref2.mediaClientConfig,
      mediaSettings = _ref2.mediaSettings,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    var parsedSettings = useMediaParsedSettings(mediaSettings);
    return /*#__PURE__*/React.createElement(MediaContext.Consumer, null, function (outterMediaProviderValue) {
      // If there is a MediaProvider up in the tree, use the top mediaClient and merge settings
      if (outterMediaProviderValue) {
        var mergedParsedSettings = _objectSpread(_objectSpread({}, outterMediaProviderValue.settings), parsedSettings);
        return /*#__PURE__*/React.createElement(MediaContext.Provider, {
          value: {
            mediaClient: outterMediaProviderValue.mediaClient,
            settings: mergedParsedSettings
          }
        }, /*#__PURE__*/React.createElement(MediaContextConsumer, {
          Component: Component,
          otherProps: otherProps
        }));
      }
      // Otherwise, check if there is a MediaClientProvider up in the tree
      return /*#__PURE__*/React.createElement(MediaClientContext.Consumer, null, function (mediaClientProviderValue) {
        return (
          // If there is a MediaClientProvider, we reinject the mediaClient and mediaSettings into a new MediaProvider
          mediaClientProviderValue ? /*#__PURE__*/React.createElement(MediaContext.Provider, {
            value: {
              mediaClient: mediaClientProviderValue,
              settings: parsedSettings
            }
          }, /*#__PURE__*/React.createElement(MediaContextConsumer, {
            Component: Component,
            otherProps: otherProps
          })) :
          /*#__PURE__*/
          // If no poviders found, we mount a MediaProvider and inject the given props mediaClientConfig and mediaSettings
          React.createElement(MediaProvider, {
            mediaClientConfig: mediaClientConfig,
            mediaSettings: mediaSettings
          }, /*#__PURE__*/React.createElement(MediaContextConsumer, {
            Component: Component,
            otherProps: otherProps
          }))
        );
      });
    });
  };
};